document.addEventListener('DOMContentLoaded', () => {
    init();
});

const init = () => {
    document.addEventListener('click', (evt) => {
        if (evt.target.classList.contains('lb-xs-atc-button')) {
            lbAddXsToCart(evt);
        }
    });
};

const lbAddXsToCart = (evt) => {
    evt.preventDefault();
    const productId = evt.target.dataset.id;
    const variantId = document.getElementById(`product-${productId}-variant`).value;
    const qty = document.getElementById('lb-xs-quantity').value;
    fetch('/cart/add.js', {
        method: 'POST',
        cache: 'no-cache',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({
            items: [
                {
                    'id': variantId,
                    'quantity': qty,
                    'properties': {
                        '__xs': true,
                    },
                },
            ],
            sections: getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
        }),
    }).then((response) => response.text()).then((data) => {
        updateCart(data);
    });
};

const updateCart = (state) => {
    const cartObj = document.getElementById('lb-cart-items');
    const parsedState = JSON.parse(state);

    getSectionsToRender().forEach((section => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
        elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));
    cartObj.currentItemCount = Array.from(document.querySelectorAll('[name="updates[]"]')).
        reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
};

const getSectionsToRender = () => {
    return [
        {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items').dataset.id,
            selector: '.js-contents',
        },
        {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
        },
        {
            id: 'cart-live-region-text',
            section: 'cart-live-region-text',
            selector: '.shopify-section',
        },
        {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer').dataset.id,
            selector: '.js-contents',
        },
        {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer').dataset.id,
            selector: '.xs-contents',
        }
    ];
};

const getSectionInnerHTML = (html, selector) => {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
};